import { AdminReservationsTable } from '@/components/dashboard/ReservationsTables';
import StyledContainer from '@/components/styled/StyledContainer';
import MetricDisplay from '@/components/ui/MetricDisplay';
import { EstimateStatus } from '@/types/estimates/EstimateStatus';
import { useTranslation } from '@/i18n';

const AdminStatsPage = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <div className="flex flex-col gap-6 p-6 items-start grow bg-brand-25 h-full">
        <div className="flex flex-1 flex-col md:flex-row gap-6 self-stretch">
          <div className="flex flex-1 flex-col gap-6">
            <MetricDisplay
              title={t('pages.admin.confirmedReservations')}
              subText={t('pages.admin.confirmedReservationsDescription')}
              childPosition="bottom"
            >
              <AdminReservationsTable status={EstimateStatus.RESERVED} />
            </MetricDisplay>
            <MetricDisplay
              title={t('pages.admin.reservationRequests')}
              subText={t('pages.admin.reservationRequestsDescription')}
              childPosition="bottom"
            >
              <AdminReservationsTable status={EstimateStatus.ESTIMATE} />
            </MetricDisplay>
            <MetricDisplay
              title={t('pages.admin.estimatesInProgress')}
              subText={t('pages.admin.estimatesInProgressDescription')}
              childPosition="bottom"
            >
              <AdminReservationsTable status={EstimateStatus.PENDING} />
            </MetricDisplay>
          </div>
        </div>
      </div>
    </StyledContainer>
  );
};

export default AdminStatsPage;
